export function getRequiredStepCodes(stepData = []) {
  return [...stepData]
    .filter((item) => item?.isRequired === 'Y')
    .sort((a, b) => Number(a?.stepOrder ?? 0) - Number(b?.stepOrder ?? 0))
    .map((item) => item.stepCode)
    .filter(Boolean);
}

export function shouldOpenMeetingDrawerOnNext(stepData = [], currentStepCode) {
  if (!currentStepCode) return false;
  const orderedStepCodes = getRequiredStepCodes(stepData);
  const currentIndex = orderedStepCodes.indexOf(currentStepCode);
  if (currentIndex < 0) return false;
  return orderedStepCodes[currentIndex + 1] === 'TBM_MEET';
}
